<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">{{model.Title}}</b-card-header>
      <b-card-body>
        <div class="list-wrapper" v-show="model.OpcionesMiPrestamo">
          <div class="list-row">
            <div class="list-property">
              <div class="list-row-item">
                <div
                  class="row"
                  width="40px"
                  style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
                >
                  <div class="col-md-1">
                    <img src="@/assets/load_sol.png" width="40px" />
                  </div>
                  <div class="col-md-4 h4" v-on:click="solicitarPrestamo">Solicitar Préstamo</div>
                </div>
              </div>
              <div class="list-row-item">
                <div
                  class="row"
                  width="40px"
                  style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0;"
                >
                  <div class="col-md-1">
                    <img src="@/assets/loan_history.png" width="40px" />
                  </div>
                  <div
                    class="col-md-4 h4"
                    style="margin-top:10px;"
                    v-on:click="consultarPrestamo"
                  >Consulta de Mi Préstamo</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<style>
</style>
<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import dateTimeHelpers from "@/helpers/datetimeHelpers";

export default {
  name: "miprestamo",
  props: {},

  data() {
    return {
      model: {
        Title: String,
        OpcionesMiPrestamo: Boolean,
        Credito: {
          VigenteDesde: Date,
          VigenteHasta: Date,
          DescripcionProductoCredito: String,
          Importe: Number
        }
      }
    };
  },
  computed: {},
  methods: {
    async solicitarPrestamo() // function()
    {
      let context = this;
      let ip = window.location.host;
      let req = { IPDispositivo: ip };
      axiosHelpers.axiosPost(
        "CreditoWenance/SolicitarCredito",
        req,
        this,
        function(data) {
          if (data.ResponseVM.Resultado) {
            let route = context.$router.resolve(data.ResponseVM.UrlARedirigir);
            //hago esto porque la URL que mandan arranca con / y te toma como dominio relativo y le agrega el localhost
            if (route.href.charAt(0) == "/") {
              window.open(route.href.substring(1), "_blank");
            }
          } else {
            // -- Solicitud Pendiente
            if (data.ResponseVM.SolicitudPendiente) {
              context.$router.push("solicitudPendiente");
            }
            // -- Rechazada por Wenance
            else if (data.ResponseVM.RechazadoPorWenance) {
              context.$router.push("miprestamorechazado");
            }
          }
        }
      );
    },

    consultarPrestamo: function() {
      let context = this;
      context.$router.push("misprestamos");
    },

    btnAceptarPrestamo() {
      let context = this;
      context.$router.push("Dashboard");
    },

    cargarDatos() {
      let context = this;
      context.model.OpcionesMiPrestamo = true;
      context.model.Title = "Mi Préstamo";
      let req = { EntityID: context.$store.getters.accountID };
      axiosHelpers.axiosPost(
        "CreditoWenance/ConsultarSolicitudCredito",
        req,
        this,
        function(data) {
          if (!data.ResponseVM.Resultado) {
            // -- Si No tiene validacion de identidad validada reedirecionamos
            if (!data.ResponseVM.ValidacionAccesoWenance.IdentidadValidada) {
              context.$router.push("verificacionidentidad");
            }
            // -- Si No tiene la  si tiene la info de renaper validada reedirecionamos
            else if (
              !data.ResponseVM.ValidacionAccesoWenance
                .InformacionRenaperValidada
            ) {
              context.$router.push("RenaperInfo");
            }
          }
        }
      );
    }
  },

  beforeMount() {
    this.cargarDatos();
  }
};
</script>